const itemsMap = {
  profile: {
    order: 1,
    title: '个人信息',
    icon: 'mdi-account',
    page: 'Profile'
  },
  user: {
    order: 2,
    title: '用户管理',
    icon: 'mdi-account-group',
    page: 'User'
  },
  role: {
    order: 3,
    title: '角色管理',
    icon: 'mdi-puzzle',
    page: 'Role'
  },
  // urlInfos: {
  //   order: 10,
  //   title: '信息管理',
  //   icon: 'mdi-cloud-print',
  //   page: 'UrlInfo'
  // },
  // urlInfos: {
  //   order: 10,
  //   title: '信息管理',
  //   icon: 'mdi-cloud-print',
  //   page: 'UrlInfo'
  // },
  urlInfos: {
    order: 10,
    title: '用户列表',
    icon: 'mdi-cloud-print',
    page: 'UrlInfo'
    // children: [{
    //   order: 11,
    //   title: '用户列表',
    //   page: 'UrlInfo'
    // }, {
    //   order: 29,
    //   title: '申请审核',
    //   page: 'applicationReview'
    // }]
  },
  applicationReview: {
    order: 11,
    title: '审核列表',
    icon: 'mdi-file-find',
    page: 'applicationReview'
  },
  appInfo: {
    order: 15,
    title: '应用版本',
    icon: 'mdi-android-studio',
    page: 'AppInfo'
  },
  themeInfo: {
    order: 17,
    title: '主题管理',
    icon: 'mdi-palette',
    page: 'ThemeInfo'
  },
  menuManage: {
    order: 19,
    title: '菜单管理',
    icon: 'mdi-menu',
    page: 'menuList'
  },
  schemeManage: {
    order: 18,
    title: '方案管理',
    icon: 'mdi-page-layout-body',
    page: 'schemeList'
  },
  appStore: {
    order: 21,
    title: '应用管理',
    icon: 'mdi-hexagon-slice-6',
    page: 'appList'
  },
  componentManage: {
    order: 25,
    title: '组件列表',
    icon: 'mdi-view-quilt-outline',
    page: 'componentList'
    // children: [{
    //   order: 25,
    //   title: '组件列表',
    //   page: 'componentList'
    // }, {
    //   order: 26,
    //   title: '组件类型',
    //   page: 'componentType'
    // }]
  },
  componentType: {
    order: 26,
    title: '组件类型',
    icon: 'mdi-view-quilt-outline',
    page: 'componentType'
    // children: [{
    //   order: 25,
    //   title: '组件列表',
    //   page: 'componentList'
    // }, {
    //   order: 26,
    //   title: '组件类型',
    //   page: 'componentType'
    // }]
  },
  basePlat: {
    order: 16,
    title: '平台类型',
    icon: 'mdi-apple-airplay',
    page: 'basePlat'
  },
  payManage: {
    order: 27,
    title: '支付管理',
    icon: 'mdi-fedora',
    page: 'payManage'
  },
  companyManage: {
    order: 28,
    title: '厂商管理',
    icon: 'mdi-home-circle',
    page: 'companyManage'
  },
  // applicationReview: {
  //   order: 29,
  //   title: '申请审核',
  //   icon: 'mdi-file-find',
  //   page: 'applicationReview'
  // },
  partsManage: {
    order: 30,
    title: '配件管理',
    icon: 'mdi-dumbbell',
    page: 'partsManage'
  },
  unifiedIdentityAuth: {
    order: 31,
    title: '统一身份认证',
    icon: 'mdi-file-replace-outline',
    page: 'unifiedIdentityAuth'
  }
}

const roleMap = {
  root: ['profile', 'role', 'user', 'appInfo', 'basePlat', 'urlInfos', 'applicationReview', 'themeInfo', 'appStore', 'componentManage', 'componentType', 'menuManage', 'schemeManage', 'payManage', 'companyManage', 'partsManage', 'unifiedIdentityAuth'],
  'user-base': ['profile'],
  'user-admin': ['user'],
  'role-admin': ['role']
}

export function generateMenu (roles) {
  // Profile 是默认页面，所有用户都有
  const menu = { profile: true }
  roles.forEach(r => {
    roleMap[r].forEach(item => {
      menu[item] = true
    })
  })
  const menuList = Object.keys(menu).map(mk => itemsMap[mk])
  return menuList.sort((a, b) => a.order - b.order)
}
